/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const HOMOLOGOUS_PROCEDURE_BEGIN = 'HOMOLOGOUS_PROCEDURE_BEGIN';
export const HOMOLOGOUS_PROCEDURE_SUCCESS = 'HOMOLOGOUS_PROCEDURE_SUCCESS';
export const HOMOLOGOUS_PROCEDURE_FAILURE = 'HOMOLOGOUS_PROCEDURE_FAILURE';
export const HOMOLOGOUS_PROCEDURE_CLEAR = 'HOMOLOGOUS_PROCEDURE_CLEAR';

export const HOMOLOGOUS_PROCEDURE_FILTER_BEGIN = 'HOMOLOGOUS_PROCEDURE_FILTER_BEGIN';
export const HOMOLOGOUS_PROCEDURE_FILTER_SUCCESS = 'HOMOLOGOUS_PROCEDURE_FILTER_SUCCESS';
export const HOMOLOGOUS_PROCEDURE_FILTER_FAILURE = 'HOMOLOGOUS_PROCEDURE_FILTER_FAILURE';
export const HOMOLOGOUS_PROCEDURE_FILTER_CLEAR = 'HOMOLOGOUS_PROCEDURE_FILTER_CLEAR';

export function fetchHomologousProcedure(params = {}) {
	return async dispatch => {
        dispatch(homologousProcedureBegin());
        await ApiService.getClientProcedure(params)
			.then(
            result => {
                dispatch(homologousProcedureSuccess(result));
				},
				error => {
                    dispatch(homologousProcedureError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export function fetchHomologousProcedureFilter(params = {}) {
    return async dispatch => {
        dispatch(homologousProcedureFilterBegin());
        await ApiService.getClientProcedureFilter(params)
            .then(
                result => {
                    dispatch(homologousProcedureFilterAdd(result));
                },
                error => {
                    dispatch(homologousProcedureFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

//HomologousProcedure
export const homologousProcedureBegin = () => ({
    type: HOMOLOGOUS_PROCEDURE_BEGIN,
});

export const homologousProcedureSuccess = data => ({
    type: HOMOLOGOUS_PROCEDURE_SUCCESS,
	payload: { data }
})

export const homologousProcedureError = () => ({
    type: HOMOLOGOUS_PROCEDURE_FAILURE,
})

export const homologousProcedureClear = () =>({
    type: HOMOLOGOUS_PROCEDURE_CLEAR,
})

//HomologousProcedure Filters
export const homologousProcedureFilterBegin = () => ({
    type: HOMOLOGOUS_PROCEDURE_FILTER_BEGIN,
});
export const homologousProcedureFilterAdd = filterData => ({
    type: HOMOLOGOUS_PROCEDURE_FILTER_SUCCESS,
    payload: { filterData }
})
export const homologousProcedureFilterError = filterError => ({
    type: HOMOLOGOUS_PROCEDURE_FILTER_FAILURE,
    payload: { filterError }
})

export const homologousProcedureFilterClear = () => ({
    type: HOMOLOGOUS_PROCEDURE_FILTER_CLEAR,
})
